import { NxpActionMenuConfig } from '@pershing/pershing-common';

export abstract class GainLossConstants {
    static DELAYED: string = 'D';
    static REALTIME: string = 'R';
    static ACCOUNT_ENTITLEMENT_ERROR = '403';
    static PAGINATION_PAGE_SIZE: number = 50; // default page size value
    static MAX_EXPORT_PAGE_SIZE: number = 9999999;
    static ACCOUNT_NO_DATA = 'This account does not have any unrealized gainloss. To view unrealized gainloss for another account, enter the account number or short name in the Search field and press Enter on your keyboard or select the desired account from the search results.';
    static INVALID_ACCOUNT = 'Account number is not available, please check your entry.';
    static SYSTEM_ERROR = 'The system is unable to process your request at this time. Please try again later.';
    static TIMEOUT_ERROR = 'Timeout, the system is unable to process your request at this time. Please try again later.';
    static INSUFFCIENT_ENTITLEMENT_ERROR = 'You do not have the entitlements required for this feature. Please contact your System Administrator for assistance.';
    static HELDAWAY_ERROR = 'All accounts in this Household/Client are not held in custody at Pershing and therefore the system is unable to retrieve your requested information';
    static PLATFORM_RETAIL = 'retail';
    static PLATFORM_PROFESSIONAL = 'professional';
    static RIGHT_ALIGN = 'right-align';
    static COST_BASIS = 'costbasis';
    static WINDOW_PARAMS = 'status=0,title=0,height=600,width=950,scrollbars=no';
    static BASE_CURRENCY = 'Base Currency';
    static NO_DATA_EXPORT = 'getAccountUglForExport(): No Data Found';
    static EXCLUDE_TEXT = '-exclude';
    static RGL_ACTION_MENU_EXCLUDE = [
        // Trading menus
        NxpActionMenuConfig.ID_TRADE_AWAY_FI + GainLossConstants.EXCLUDE_TEXT,
        NxpActionMenuConfig.ID_TRADE_BUY_529 + GainLossConstants.EXCLUDE_TEXT,
        NxpActionMenuConfig.ID_TRADE_BUY_CALLS_TO_OPEN + GainLossConstants.EXCLUDE_TEXT,
        NxpActionMenuConfig.ID_TRADE_BUY_MF + GainLossConstants.EXCLUDE_TEXT,
        NxpActionMenuConfig.ID_TRADE_BUY_MORE_EQUITY + GainLossConstants.EXCLUDE_TEXT,
        NxpActionMenuConfig.ID_TRADE_BUY_PUTS_TO_OPEN + GainLossConstants.EXCLUDE_TEXT,
        NxpActionMenuConfig.ID_TRADE_BUY_TO_COVER + GainLossConstants.EXCLUDE_TEXT,
        NxpActionMenuConfig.ID_TRADE_CLOSE_CALLS_PUTS + GainLossConstants.EXCLUDE_TEXT,
        NxpActionMenuConfig.ID_TRADE_EXCHANGE + GainLossConstants.EXCLUDE_TEXT,
        NxpActionMenuConfig.ID_TRADE_EXCHANGE_529 + GainLossConstants.EXCLUDE_TEXT,
        NxpActionMenuConfig.ID_TRADE_REDEEM + GainLossConstants.EXCLUDE_TEXT,
        NxpActionMenuConfig.ID_TRADE_REDEEM_529 + GainLossConstants.EXCLUDE_TEXT,
        NxpActionMenuConfig.ID_TRADE_SELL_ALL_EQUITY + GainLossConstants.EXCLUDE_TEXT,
        NxpActionMenuConfig.ID_TRADE_SELL_CALLS_TO_OPEN + GainLossConstants.EXCLUDE_TEXT,
        NxpActionMenuConfig.ID_TRADE_SELL_COVERED + GainLossConstants.EXCLUDE_TEXT,
        NxpActionMenuConfig.ID_TRADE_SELL_COVERED_OPTIONS + GainLossConstants.EXCLUDE_TEXT,
        NxpActionMenuConfig.ID_TRADE_SELL_EQUITY + GainLossConstants.EXCLUDE_TEXT,
        NxpActionMenuConfig.ID_TRADE_SELL_FI + GainLossConstants.EXCLUDE_TEXT,
        NxpActionMenuConfig.ID_TRADE_SELL_POSITIONS + GainLossConstants.EXCLUDE_TEXT,
        NxpActionMenuConfig.ID_TRADE_SELL_PUTS_TO_OPEN + GainLossConstants.EXCLUDE_TEXT,
        NxpActionMenuConfig.ID_TRADE_SELL_SHORT + GainLossConstants.EXCLUDE_TEXT,
        NxpActionMenuConfig.ID_HOLDINGS_BUY_MORE_EQUITY + GainLossConstants.EXCLUDE_TEXT,
        NxpActionMenuConfig.ID_SELL_POSITIONS + GainLossConstants.EXCLUDE_TEXT,
        NxpActionMenuConfig.ID_PERIODIC_INSTRUCTIONS + GainLossConstants.EXCLUDE_TEXT,
        NxpActionMenuConfig.ID_DIVIDEND_REINVEST + GainLossConstants.EXCLUDE_TEXT,
        NxpActionMenuConfig.ID_CALCULATE_CDSC + GainLossConstants.EXCLUDE_TEXT,
        // News menu
        NxpActionMenuConfig.ID_SECURITY_NEWS + GainLossConstants.EXCLUDE_TEXT
    ];
    static ACTIVE_SUMMARY = {
        NET: 'Net',
        GAINS: 'Gains',
        LOSSES: 'Losses',
        LONG_TERM: 'LongTerm',
        SHORT_TERM: 'ShortTerm',
      };

}